function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import PropTypes from 'prop-types';
import ThemeContext from '../theme_context';
import createTheme from '../create_theme';
import SemanticsProvider from '../semantics_provider';
import SemanticsContext from '../semantics_context';
function ThemeProvider(props) {
  var {
    children,
    customSemantics: customSemanticsProp,
    density: densityProp,
    mode: modeProp,
    shape: shapeProp,
    theme = {}
  } = props;
  var {
    customSemantics: existingCustomSemantics
  } = React.useContext(SemanticsContext);
  var customSemantics = customSemanticsProp || existingCustomSemantics;
  var contextOptions = React.useContext(ThemeContext);
  var options = React.useMemo(() => {
    var themeProps = {
      density: densityProp || contextOptions.density,
      mode: modeProp || contextOptions.mode,
      shape: shapeProp || contextOptions.shape
    };
    return _objectSpread(_objectSpread({}, themeProps), {}, {
      theme: createTheme(_objectSpread(_objectSpread({}, themeProps), {}, {
        outerTheme: theme,
        customSemantics
      }))
    });
  }, [contextOptions, customSemantics, densityProp, modeProp, shapeProp, theme]);
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: options
  }, /*#__PURE__*/React.createElement(SemanticsProvider, {
    customSemantics: customSemantics
  }, children));
}
ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
  density: PropTypes.oneOf(['standard', 'high']),
  mode: PropTypes.string,
  // deliberately relaxed so that custom modes work
  shape: PropTypes.oneOf(['round', 'sharp', 'pill'])
};
export default ThemeProvider;